module.exports = __webpack_public_path__ + "img/按钮-箭头向右_o.cac601ab.png";